import { lazy, Suspense } from 'react';

import RequirePermission from '../components/AuthGuards/RequirePermission';

const VideoDetail = lazy(() => import('../pages/VideoDetail'));

export const VideoDetailRoutes = [
  {
    path: 'video-detail/:id',
    // preview.stream: the page's core is the watermarked preview player, and
    // every role holds the permission - so in practice this is the
    // authentication gate the route never had, expressed in matrix terms.
    element: (
      <RequirePermission permission="preview.stream">
        <Suspense fallback={<></>}>
          <VideoDetail />
        </Suspense>
      </RequirePermission>
    ),
  },
];
